// extracted by mini-css-extract-plugin
export default {"hidden":"AuthFormLabel_hidden__CwuOd","loginLabel":"AuthFormLabel_loginLabel__XIXyx","labelName":"AuthFormLabel_labelName__aB8wW","input":"AuthFormLabel_input__wqGvg"};